import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TopSection from "../../LT/TopSection";
import { Stack, Typography } from "@mui/material";
import SupplierAnnouncementCard from "./SupplierAnnouncementCard";
import { getAllSupplierAnnouncementSlice } from "../../../redux/actions/GetAllSupplierAnnouncementSlice";
import { viewSupplierAnnouncementEndpoint } from "../../../common/endpoints";
import { Loader } from "../../../components/common/Loader";

const SupplierAnnouncements = () => {
    const dispatch = useDispatch();
    const [initialLoading, setInitialLoading] = useState(true);

    const [announcements, setAnnouncements] = React.useState([]);
    const loading = useSelector(
        (state) => state.getAllSupplierAnnouncementSlice?.loading
    );


    useEffect(() => {
        fetchAnnouncements();

        const interval = setInterval(() => {
            fetchAnnouncements(); // silent refresh
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const fetchAnnouncements = async () => {
        const loggedInUserEmail = localStorage.getItem("userEmail");

        try {
            const response = await dispatch(
                getAllSupplierAnnouncementSlice({
                    dynamicEndpoint: `${viewSupplierAnnouncementEndpoint}/${loggedInUserEmail}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                setAnnouncements(response.payload || []);
            } else {
                toast.error("Failed to load announcements");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
        finally {
            setInitialLoading(false);
        }
    };

    return (
        <>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Announcements" },
                ]}
                headerName="Announcements"
                hideHeader
            />

            <div style={{ padding: 8, paddingRight: 20 }}>
                <Stack spacing={2}>
                    {initialLoading ? (
                        <Loader />
                    ) : announcements?.length > 0 ? (
                        announcements.map((item) => (
                            <SupplierAnnouncementCard
                                key={item.announcementId}
                                id={item.announcementId}
                                title={item.title}
                                description={item.content}
                                date={item.createdAt}
                                postedBy={item.createdBy}
                                isNew={item.read}
                                attachmentUrl={item.attachmentUrl}
                                attachmentName={item.attachmentName}
                                attachmentType={item.attachmentType}
                                announcementType={item.announcementType}
                            />
                        ))
                    ) : (
                        <Typography
                            sx={{
                                textAlign: "center",
                                color: "#6b7280",
                                mt: 4,
                                fontSize: 14,
                            }}
                        >
                            No announcements available
                        </Typography>
                    )}
                </Stack>
            </div>
        </>
    );
};

export default SupplierAnnouncements;